<a
    ds-pill
    csAppearanceThemeModifier
    [elementType]="navItemType"
    [featureName]="featureName()"
    [currentTheme]="currentTheme()"
    [selected]="isSelected()"
    [routerLink]="computedRouterLink()"
    [href]="computedHref()"
    [class]="computedDynamicClasses()"
    (click)="handlePillClick($event)">
    <span slot="start">
        @if (enableVnIconsForPills) {
            <vn-icon [size]="vnIconSize" [name]="iconName()"></vn-icon>
        } @else {
            <span class="icn" [class]="iconName()"></span>
        }
    </span>

    {{ item().categoryname }}

    <span slot="end">
        @if (isBadgeTypeSignPosting(item().signPostingCount || 0)) {
            @if (item().signPostingCount; as count) {
                <ds-notification-bubble
                    slot="end"
                    size="large"
                    csAppearanceThemeModifier
                    [currentTheme]="currentTheme()"
                    [elementType]="notificationBubbleElement()"
                    [featureName]="featureName()">
                    {{ count > 99 ? 99 : count }}
                </ds-notification-bubble>
            }
        }
        @if (isBadgeTypeText(item().categoryid)) {
            <span slot="end" class="badge badge-square badge-offset badge-t-r badge-danger casino-navigation-badge discover-badge">{{
                categoryStickerName
            }}</span>
        }
        @if (isBadgeTypeIcon(item().categoryid)) {
            <span class="badge badge-circle badge-offset badge-t-r badge-danger casino-navigation-badge badge-icon {{ badgeIcon }}" slot="end">
            </span>
        }
    </span>
</a>
